import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {PANEL_TYPE} from "../../../../../blink-sdk/Constants";
import {iFrameState} from "../../../../services/IFrameState";
import {Flow} from "../../../flows/Flow.js";
import {AddressDescription} from "../address/components/AddressDescription.jsx";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";
import {PaymentMethodAcceptOrChange} from "../payment-method/components/PaymentMethodAcceptOrChange.jsx";


export class SubscribeReviewOrderPanelStyle extends BasePanelPageStyle {
    @styleRule
    reviewItem = {
        fontSize: this.themeProps.FONT_SIZE_NORMAL,
        marginBottom: 14,
    };

    @styleRule
    reviewItemTitleContainer = {
        display: "flex",
        justifyContent: "space-between",
    };

    @styleRule
    reviewItemDescription = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    };

    @styleRule
    reviewItemTitle = {
        textTransform: "uppercase",
        marginBottom: 4,
        fontWeight: this.themeProps.FONT_WEIGHT_BOLD,
    };

    @styleRule
    lineSeparator = {
        borderBottom: "1px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR,
        marginBottom: 14
    }
}

@registerStyle(SubscribeReviewOrderPanelStyle)
export class SubscribeReviewOrderPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.reviewOrder,
        };
    }

    render() {
        const {styleSheet} = this;
        const {panelType} = iFrameState;
        const shippingAddress = Flow.address.selectedValue;
        const selectedOffer = Flow.subscriptionPlan.selectedValue;
        const {discountCode} = Flow.subscriptionPlan;
        const discountInfo = Flow.subscriptionPlan.getDiscountInfo(selectedOffer);
        const finalPrice = discountInfo ? selectedOffer.formatPrice(discountInfo.finalPrice) : "-";
        const cycle = selectedOffer.getCycleDuration(true);

        const addressLabel = panelType === PANEL_TYPE.giftSubscription ? Messages.recipientAddress : Messages.address;
        const paymentDescription = panelType === PANEL_TYPE.giftSubscription ? Messages.giftSubscriptionPaymentDescription : Messages.subscribePaymentDescription;

        return [
            // TODO @flow this is actually incorrect when coming from a digital to a print sub, since we also need to select an address
            <div className={styleSheet.reviewItem} testId="subscriptionPlanSection">
                <div className={styleSheet.reviewItemTitleContainer}>
                    <div className={styleSheet.reviewItemTitle}>{Messages.subscriptionPlan}</div>
                    <LinkButton
                        value={Messages.change}
                        testId="changeSubscriptionPlanButton"
                        onClick={() => Flow.promptAtStep(Flow.subscriptionPlan)}
                    />
                </div>
                <MessageElement
                    className={styleSheet.reviewItemDescription}
                    message={Messages.subscriptionPlanDescription}
                    args={[selectedOffer.coverage.name, finalPrice, cycle]}
                />
            </div>,

            // TODO @flow this should actually depend on if the discount code was properly checked
            discountCode && [
                <div className={styleSheet.lineSeparator}/>,
                <div className={styleSheet.reviewItem} testId="discountSection">
                    <div className={styleSheet.reviewItemTitleContainer}>
                        <div className={styleSheet.reviewItemTitle}>{Messages.discountCode}</div>
                    </div>
                    <MessageElement
                        className={styleSheet.reviewItemDescription}
                        message={Messages.discountCodeApplied(discountCode)}
                    />
                </div>
            ],

            selectedOffer.shouldCollectAddress() && [
                <div className={styleSheet.lineSeparator}/>,
                <div className={styleSheet.reviewItem} testId="addressSection">
                    <div className={styleSheet.reviewItemTitleContainer}>
                        <div className={styleSheet.reviewItemTitle}>{addressLabel}</div>
                        <LinkButton
                            value={Messages.change}
                            testId="changeAddressButton"
                            onClick={() => Flow.address.prompt({inlineSubflow: true})}
                        />
                    </div>
                    <AddressDescription userAddress={shippingAddress} />
                </div>
            ],

            <div className={styleSheet.lineSeparator} />,
            <div className={styleSheet.reviewItem} testId="paymentMethodSection">
                <div className={styleSheet.reviewItemTitle}>
                    {Messages.payment}
                </div>
                <MessageElement
                    message={paymentDescription}
                    args={[finalPrice, cycle]}
                    className={styleSheet.reviewItemDescription}
                />
                {
                    Flow.paymentMethod.selectedValue && <PaymentMethodAcceptOrChange />
                }
            </div>,

            <BlinkButton
                label={Flow.paymentMethod.selectedValue ? Flow.paymentMethod.continueLabel : Messages.continueToPayment}
                onClick={() => Flow.subscriptionReview.updateAndResolve()}
                className={styleSheet.actionButton}
            />,

            Flow.renderBackButton(),
        ];
    }

    async onMount() {
        super.onMount();

        this.attachListener(Flow.subscriptionPlan, () => this.redraw());
    }
}
